export enum GenderDBChoices {
  male = 'ma',
  female = 'fe',
  other = 'ot',
  notStated = 'nt',
}

export enum GenderUIChoices {
  male = 'Male',
  female = 'Female',
  other = 'Other',
  notStated = 'Not Stated',
}

export const GenderSelectChoices = [
  {label: GenderUIChoices.male, value: GenderDBChoices.male},
  {label: GenderUIChoices.female, value: GenderDBChoices.female},
  {label: GenderUIChoices.other, value: GenderDBChoices.other},
  {label: GenderUIChoices.notStated, value: GenderDBChoices.notStated},
];

